<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page two_step_reg whiteandround alternative_flow_two_step_reg">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <div class="row inner_logo">
              <img src="static/images/logo.svg" alt="">
            </div>
            <span>{{ getTranslations.visitor_alternative_to_redeem_your }}</span>
          </div>
          <div class="col-lg-12">
            <div class="twoStepRegSteps_Container">
              <div class="twoStepRegSteps_step">1</div>
              <div class="twoStepRegSteps_step inactive">2</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help">
              <div class="col-12 alternative_flow_2step_reg">
                <p>{{ getTranslations.visitor_alternative_many_more }}</p>
              </div>
              <div class="col-12 center">
                <img class="alternative_flow_prizes_image" src="static/images/alternative_flow/prizes-registration.svg" />
              </div>
              <div class="col-12 alternative_flow_2step_reg">
                <p>{{ getTranslations.visitor_alternative_please_enter_your_mobile }}</p>
              </div>
            </div>

            <form action="">
              <div class="form-group"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text" class="form-group__textfield phone_input"
                       id="msisdnInputField"
                       :readOnly="!!hasHE"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_1_single_country_placeholder"
                       @keyup="check" v-model="user.msisdn"/>
                <span v-show="getMessage(message) && user.msisdn" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>
              <input type="submit"
                     :value="(!hasHE) ? getTranslations.visitor_sign_up_1_single_country_submit_button_continue : getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitAction">
              <div class="col-12 alternative_flow_2step_reg">
              <p>
                {{ getTranslations.visitor_sign_up_1_single_country_already_have_account }}
                <router-link :to="'login'">{{ getTranslations.visitor_sign_up_1_single_country_login }}</router-link>
              </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <confirmation v-if="showConfirmationModal"
                  @confirm="showConfirmationModal = false;getNextVerificationStep()();"
                  @close="showConfirmationModal = false;">
    </confirmation>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import FlowMixin from '@/common/mixins/flow';
import confirmation from '@/components/home/modals/Confirm';

export default {
  name: 'alternative-sign-up-1-single-country',
  components: { confirmation },
  mixins: [IntegrationMixin, FlowMixin],
  data() {
    return {
      operatorLogoForBrandedProject: '',
      btnSubmitted: false,
      operatorPicked: '',
      user: {
        msisdn: '',
        hash: '',
      },
      message: '',
      hasErrors: false,
      defaultImagePath: '/ext/banners/RegistrationDefault.png',
      imageUsed: '',
      waitForResponse: false,
      showConfirmationModal: false,
    };
  },
  created() {
    const numOfVisibleOperators = (this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(item => item)).length;
    if (numOfVisibleOperators === 1) {
      const position = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.indexOf(true);
      const operator = this.multiOperatorInfo.multiOperatorKeys[position];
      this.storeOperator(operator);
      this.operatorPicked = operator;
    }
    if (this.$route.query.errorMessage) this.message = this.getTranslatedErrorMessage(this.$route.query.errorMessage);
    if (this.message) {
      this.user.msisdn = this.$route.query.errorMsisdn || '';
      this.hasErrors = true;
    } else if (this.getIntegrationByName()) {
      this.user.msisdn = this.$route.query.heMsisdn || '';
      this.user.hash = this.$route.query.heHash || '';
      this.setCorrelationId({ value: this.$route.query.cid || '' });
      this.$nextTick(() => {
        this.hasHE = this.user.msisdn && this.user.hash && this.isSingleOptIn();
      });
    }
    this.imageUsed = this.banner ? `/ext/banners/${this.banner}.jpg` : this.defaultImagePath;
    this.operatorLogoForBrandedProject = this.isBrandedProject ? `static/skins/skin_${this.duelSkin.toString()}/images/logo-operator.svg` : '';
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setCorrelationId',
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    showOperators() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || !activeIntegration.value.affectsMultiOperator;
    },
    showDisclaimerNotice() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_free_for');
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer');
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    getTranslatedErrorMessage(errorMessage) {
      switch (errorMessage) {
      case 'MSISDN_INVALID': return 'visitor_sign_up_invalid_msisdn_msg';
      case 'ALREADY_REGISTERED': return 'visitor_sign_up_msisdn_already_registered';
      case 'MSISDN_NOT_EXIST': return 'visitor_sign_up_msisdn_not_exists';
      case 'MSISDN_BLACKLISTED': return 'visitor_sign_up_msisdn_blacklisted';
      case 'BLOCKED_USER': return 'visitor_forgot_password_warning_msd_max_attempts';
      case 'CAMPAIGN_CLOSED': return 'visitor_sign_up_campaign_closed';
      case 'SERVER_ERROR': return 'home_profile_profile_edit_server_unvailable';
      default: return 'visitor_sign_up_warning_third_party_error';
      }
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    imageErrorHandler() {
      this.imageUsed = this.defaultImagePath;
    },
    check() {
      const validMsisdnRegex = /^[0-9]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    mapErrorMessages(resMessage) {
      if (resMessage === 'MSISDN_INVALID') {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
      } else if (resMessage === 'ALREADY_REGISTERED') {
        this.message = 'visitor_sign_up_msisdn_already_registered';
      } else if (resMessage === 'MSISDN_NOT_EXIST') {
        this.message = 'visitor_sign_up_msisdn_not_exists';
      } else if (resMessage === 'MSISDN_BLACKLISTED') {
        this.message = 'visitor_sign_up_msisdn_blacklisted';
      } else if (resMessage === 'BLOCKED_USER') {
        this.message = 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resMessage === 'CAMPAIGN_CLOSED') {
        this.message = 'visitor_sign_up_campaign_closed';
      } else if (resMessage === 'SERVER_ERROR') {
        this.message = 'home_profile_profile_edit_server_unvailable';
      } else if ((resMessage === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resMessage === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resMessage === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        this.message = 'visitor_sign_up_warning_third_party_error';
      }
    },
    onSubmitAction() {
      this.btnSubmitted = true;
      if (!this.multiOperatorInfo.multiOperatorEnabled || (this.multiOperatorInfo.multiOperatorEnabled && this.operatorPicked)) {
        this.checkButton();
      } else {
        this.hasErrors = true;
      }
    },
    checkButton() {
      const activeIntegration = this.getIntegrationByName();
      if (activeIntegration && activeIntegration.value.hasConfirmation && this.isSingleOptIn()) {
        this.showConfirmationModal = true;
      } else this.getNextVerificationStep()();
    },
  },
  computed: {
    ...mapState('common', [
      'duelSkin',
      'banner',
      'isBrandedProject',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/AlternativeTwoStepRegistration1.vue